import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/easyterra.webp';
import screenshot_target from '../../../images/letterfunnel/erikbaan.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Erik Baan"
      firstname="Erik"
      companyname="EasyTerra"
      competition="Sunny Cars en DiscoverCars.com"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/erikbaan.js